function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    getSelectedOptionValues() {
      const values = [];
      this.querySelectorAll('.product-form__input').forEach((container) => {
        const checkedInput = container.querySelector('input[type="radio"]:checked');
        const select = container.querySelector('select');
        if (checkedInput) {
          values.push(checkedInput.value);
        } else if (select) {
          values.push(select.value);
        }
      });
      return values;
    }

    getSelectedVariant() {
      const script = this.querySelector('script[type="application/json"]');
      if (!script) return null;
      let variants;
      try {
        variants = JSON.parse(script.textContent);
      } catch (e) {
        return null;
      }
      const values = this.getSelectedOptionValues();
      if (!values.length) return null;
      return variants.find((variant) =>
        values.every((value, index) => variant[`option${index + 1}`] === value)
      );
    }

    updateVariantInputs(variant) {
      document.querySelectorAll('input[name="id"]').forEach((input) => {
        input.value = variant.id;
        input.disabled = false;
      });
    }

    updateURL(variant) {
      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${variant.id}`);
    }

    updateAddToCartButton(variant) {
      const sectionId = this.dataset.section;
      const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
      if (!button) return;
      button.disabled = !variant.available;
      button.toggleAttribute('data-unavailable', !variant.available);
    }

    swapSectionPiece(newDoc, id) {
      const newEl = newDoc.getElementById(id);
      const oldEl = document.getElementById(id);
      if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
    }

    async onVariantChange() {
      const variant = this.getSelectedVariant();
      if (!variant) return;

      this.updateVariantInputs(variant);
      this.updateURL(variant);
      this.updateAddToCartButton(variant);

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));

      const sectionId = this.dataset.section;
      const url = `${this.dataset.url}?variant=${variant.id}&section_id=${sectionId}`;

      try {
        const response = await fetch(url);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');

        this.swapSectionPiece(html, `price-${sectionId}`);
        this.swapSectionPiece(html, `Inventory-${sectionId}`);
        this.swapSectionPiece(html, `Sku-${sectionId}`);
        this.swapSectionPiece(html, `main-atc-price-${sectionId}`);
      } catch (e) {
        console.error('variant-selects sync error', e);
      }
    }
  }

  customElements.define('variant-selects', VariantSelects);
}